import React from "react"
import { Props, State } from "./types/component"
import { isError } from "@appsignal/core"

export class ErrorBoundary extends React.Component<Props, State> {
  state = { error: undefined }

  static defaultProps = {
    action: ""
  }

  static getDerivedStateFromError(error: Error): State {
    return isError(error) ? { error } : {}
  }

  public componentDidCatch(error: Error): void {
    if (!isError(error)) return

    const { instance: appsignal, action, tags = {} } = this.props
    const span = appsignal.createSpan()

    span.setError(error).setTags({ framework: "React", ...tags })

    if (action && action !== "") span.setAction(action)

    appsignal.send(span)

    // fall back if getDerivedStateFromError wasn't called before
    // componentDidCatch. fixes support for react 16 - 16.6.
    if (!this.state.error) this.setState({ error })
  }

  public render(): React.ReactNode {
    if (this.state.error) {
      return this.props.fallback ? this.props.fallback(this.state.error) : null
    }

    return this.props.children
  }
}
